import { CustomerDto } from "../../../interfaces/IEvent";
import { Box, Divider, Grid, Typography } from "@mui/material";
import { EbStack } from "@eidsivabredband/react-component-ui-package";
import { EntityLink } from "../../../components/AffectedEntities/EntityLink";

interface AffectedInfoSearchFieldProps {
    customer: CustomerDto[];
    search: string;
    onNavigate?: () => void;
}

export function AffectedInfo({customer, search, onNavigate}: AffectedInfoSearchFieldProps){
    return (
        <>
            {customer.filter((customer) => {
                const searchLower = search.toLowerCase();
                const customerNameMatch = customer.customerName?.toLowerCase().includes(searchLower);
                const customerNumberMatch = customer.customerNumber?.toLowerCase().includes(searchLower);
                const addressIdMatch = customer.affectedAddresses?.some(location => location.addressId?.toLowerCase().includes(searchLower));
                const servicePointIdMatch = customer.affectedAddresses?.some(location => location.servicePointId?.toLowerCase().includes(searchLower));
                const connectionNumbersMatch = customer.affectedAddresses?.some(location => location.connectionNumbers?.join(", ").toLowerCase().includes(searchLower));

                return search === "" || customerNameMatch || customerNumberMatch || addressIdMatch || servicePointIdMatch || connectionNumbersMatch;
            }).map((customer, index) => {
                return (
                    <Box key={index}>
                        <Divider variant="fullWidth" sx={{ borderStyle: "outset" }} />
                        <Grid
                            container
                            sx={{
                                pt: 1,
                                pb: 1
                            }}>
                            <Grid
                                size={{
                                    xs: 12,
                                    md: 12
                                }}>
                                <Typography variant="body2" sx={{
                                    fontWeight: 600
                                }}>
                                    {customer.customerNumber ? (
                                        <EntityLink kind="CustomerNumber" value={customer.customerNumber} onNavigate={onNavigate}>
                                            {customer.customerNumber}
                                        </EntityLink>
                                    ) : customer.customerNumber}
                                    {" - "}{customer.customerName} ({customer.affectedAddresses.length})
                                </Typography>
                            </Grid>
                            {customer.affectedAddresses && customer.affectedAddresses.map((location, index) => {
                                return (
                                    <Grid key={index} size={12}>
                                        <EbStack>
                                            <Typography variant="caption">
                                                {location.servicePointId ? (
                                                    <EntityLink kind="ServicePointId" value={location.servicePointId} onNavigate={onNavigate}>
                                                        {location.servicePointId}
                                                    </EntityLink>
                                                ) : ""}
                                            </Typography>
                                            <Typography variant="caption">
                                                {location.connectionNumbers?.length > 0 && (
                                                    <>
                                                        {" - "}
                                                        {location.connectionNumbers.map((cn, i) => (
                                                            <span key={cn}>
                                                                {i > 0 && ", "}
                                                                <EntityLink kind="ConnectionNumber" value={cn} onNavigate={onNavigate}>
                                                                    {cn}
                                                                </EntityLink>
                                                            </span>
                                                        ))}
                                                    </>
                                                )}
                                            </Typography>
                                        </EbStack>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    </Box>
                );})}
        </>
    );
}